module.exports = __webpack_public_path__ + "img/xcgl.9a835be4.png";